// Keyword-optimised SEO landing pages: /airport-transfer-{slug}
// Short, high-search slugs. cityId maps to a valid /api/cities id.
export const CITY_LANDINGS = [
  { slug: "zurich", cityId: "zurich-hb", name: { de: "Zürich", en: "Zürich" } },
  { slug: "bern", cityId: "bern", name: { de: "Bern", en: "Bern" } },
  { slug: "basel", cityId: "basel", name: { de: "Basel", en: "Basel" } },
  { slug: "geneva", cityId: "geneva", name: { de: "Genf", en: "Geneva" } },
  { slug: "lucerne", cityId: "lucerne", name: { de: "Luzern", en: "Lucerne" } },
  { slug: "lugano", cityId: "lugano", name: { de: "Lugano", en: "Lugano" } },
  { slug: "st-moritz", cityId: "stmoritz", name: { de: "St. Moritz", en: "St. Moritz" } },
  { slug: "davos", cityId: "davos", name: { de: "Davos", en: "Davos" } },
  { slug: "zermatt", cityId: "zermatt", name: { de: "Zermatt", en: "Zermatt" } },
  { slug: "interlaken", cityId: "interlaken", name: { de: "Interlaken", en: "Interlaken" } },
  { slug: "grindelwald", cityId: "grindelwald", name: { de: "Grindelwald", en: "Grindelwald" } },
  { slug: "lausanne", cityId: "lausanne", name: { de: "Lausanne", en: "Lausanne" } },
  { slug: "montreux", cityId: "montreux", name: { de: "Montreux", en: "Montreux" } },
  { slug: "gstaad", cityId: "gstaad", name: { de: "Gstaad", en: "Gstaad" } },
  { slug: "arosa", cityId: "arosa", name: { de: "Arosa", en: "Arosa" } },
  { slug: "flims-laax", cityId: "flims", name: { de: "Flims Laax", en: "Flims Laax" } },
  { slug: "engelberg", cityId: "engelberg", name: { de: "Engelberg", en: "Engelberg" } },
  { slug: "andermatt", cityId: "andermatt", name: { de: "Andermatt", en: "Andermatt" } },
  { slug: "verbier", cityId: "verbier", name: { de: "Verbier", en: "Verbier" } },
  { slug: "saas-fee", cityId: "saas-fee", name: { de: "Saas-Fee", en: "Saas-Fee" } },
  { slug: "bad-ragaz", cityId: "bad-ragaz", name: { de: "Bad Ragaz", en: "Bad Ragaz" } },
  { slug: "appenzell", cityId: "appenzell", name: { de: "Appenzell", en: "Appenzell" } },
  { slug: "baden", cityId: "baden", name: { de: "Baden", en: "Baden" } },
  { slug: "lenzerheide", cityId: "lenzerheide", name: { de: "Lenzerheide", en: "Lenzerheide" } },
];

export const landingBySlug = (slug) => CITY_LANDINGS.find((c) => c.slug === slug);
